export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="bg-white border-b border-[#d9cfb8] px-8 py-6 flex items-end justify-between gap-6">
      <div>
        <div className="text-[10px] tracking-[0.3em] text-[#8b7e5e] uppercase">
          MINISTERIOS ÁRBOLES JUNTO AL RÍO
        </div>
        <h1 className="text-3xl font-serif text-[#1c1a14] mt-1">{title}</h1>
        {subtitle && <p className="text-sm text-[#5d5849] mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
